const initialState = {
    id: null,
    firstName: null,
    lastName: null,
    email: null,
    signupComplete: false,
    isFetching: false,
    sessionToken: '',
    token:'',
    user: null,
    currentOrganization: null,
    isLoginLoading: false,
    selectedLanguage: "en",
    isAuth0UserRegistering: false,
    auth0UserRegistered: false,
    auth0UserRegisterFailed:false,
}

export default initialState;